import Vue from 'vue';
import revenueUrls from '../../../urls/revenueUrls';
import filterTypes from '../filterTypes';
import reportTypes from '../ReportTypes';
import columnNames from '../columnNames';

import { revenueFilterItems, revenueReportItems } from '../model';

import { stringify } from 'querystring';
import dataTableFilter from '../../../components/Common/DataTable/dataTableFilter';

const storePrefix = "revenue_store_";

const state = {

    sessionStorageKey: "ss_RevenueReport",

    revenueData: null,

    revenueTime: {
        from: null,
        to: null,
        period: null
    },

    revenueReports: new revenueReportItems().items,

    currentReport: new revenueReportItems().items[0],

    revenueDatatableFilters: [],

    revenueFilterItems: new revenueFilterItems().items,

    revenueAppsDetails: [],

    isAllowedAdvertiserReport: false

}

const getters = {

    getCurrentReport(state) {
        return state.currentReport;
    },

    getRevenueReports(state) {
        return state.revenueReports;
    },

    getFilteredRevenueReports(state, rootState) {
        const pbEmail = rootState.getPublisherEmail;
        if (pbEmail == samsungUserEmail && !_isAdmin) {
            return state.revenueReports.filter(report => {
                // Replace the condition with your actual filter logic
                return report.name === 'Date' || report.name === 'Country';
            });
        } else {
            return state.revenueReports;
        }
    },

    isSamsung(state, rootState) {
        const pbEmail = rootState.getPublisherEmail;
        return (pbEmail == samsungUserEmail);
    },

    getRevenueFiltersDataTable(state) {
        return state.revenueDatatableFilters;
    },

    getRevenueData(state) {
        return state.revenueData;
    },

    getRevenueTime(state) {
        return state.revenueTime;
    },

    getRevenueFilterItems(state) {
        return state.revenueFilterItems;
    },

    getRevenueAppsDetails(state) {
        return state.revenueAppsDetails;
    },

    getSessionStorageKey(state) {
        return state.sessionStorageKey;
    },

    getAllowAdvertiserReport(state) {
        return state.isAllowedAdvertiserReport;
    }
}

const mutations = {

    [`${storePrefix}setAllSelectedItems`](state, payload) {
        let filterTypeName = payload.filterTypeName;
        let column = payload.column;
        let value = payload.value;
        let filteredItems = payload.filteredItems;
        let remove = payload.remove;

        let datatableFilter = state.revenueDatatableFilters.find((c) => {
            return c.column == column;
        });

        if (remove && remove === true && datatableFilter) {

            filteredItems.forEach(item => {
                item.selected = false;
            });

            filteredItems.forEach(item => {

                let filterOptionIndex = datatableFilter.values.findIndex(value => {

                    if (typeof value === "string") {
                        return value == item.name;
                    } else if (typeof value === "number") {
                        return value == item.id;
                    }

                });

                if (filterOptionIndex > -1) {
                    datatableFilter.values.splice(filterOptionIndex, 1);
                }
            });

            if (datatableFilter.values.length === 0) {
                let datatableFilterIndex = state.revenueDatatableFilters.findIndex((c) => {
                    return c.column == column;
                });
                state.revenueDatatableFilters.splice(datatableFilterIndex, 1);
            }

        } else {

            // datatable filters
            if (datatableFilter) {

                let values = [];

                filteredItems.forEach(item => {
                    if (item.isAll === false && item.selected === false) {

                        if (typeof item.id === "number") {
                            values.push(item.id);
                        }else if (typeof item.name === "string") {
                            values.push(item.name);
                        }
                    }
                });

                state.revenueDatatableFilters.forEach(item => {

                    if (item.column === column) {
                        values.forEach(vItem => {
                            item.values.push(vItem);
                        });
                    }

                });

            } else {

                let values = [];

                filteredItems.forEach(item => {

                    if (item.isAll === false) {

                        if (columnNames.pba_number === column || columnNames.advertiserId === column) {
                            values.push(item.id);
                        } else if (typeof item.id === "number") {
                            values.push(item.id);
                        } else if (typeof item.name === "string") {
                            values.push(item.name);
                        }

                    }
                });

                let currentDatatableFilter = {
                    column: column,
                    values: values,
                    byValue: true
                };

                state.revenueDatatableFilters.push(currentDatatableFilter);
            }

            // filters
            filteredItems.forEach(item => {
                item.selected = true;
            });

        }
    },

    [`${storePrefix}setIsAllSelected`](state, payload) {

        let filterTypeName = payload.filterTypeName;
        let isAllSelected = payload.isAllSelected;
        let filteredOptions = payload.filteredItems;
        let unFilteredOptions = payload.unFilteredItems;

        let filterItem = state.revenueFilterItems.find(item => {
            return item.id === filterTypeName;
        });

        if (filterItem) {

            let option = filterItem.options.find(item => {
                return item.isAll === true;
            });

            if (option) {

                option.isAllSelected = isAllSelected;

                let options = filteredOptions.filter(item => {
                    return item.selected === true || item.isAll === true;
                });

                if (isAllSelected === true) {
                    option.name = "Select All Results";

                    if (options.length === filteredOptions.length) {
                        option.selected = true;
                    } else {
                        option.selected = false;
                    }

                } else {
                    option.name = "All " + option.id;

                    if (options.length === 1) { // only isAll selected
                        option.selected = true;
                    } else {
                        option.selected = false;
                    }
                }
            }
        }
    },

    [`${storePrefix}setDrpItemsVisibleForAdmin`](state) {

        state.revenueReports.forEach(item => {
            if (item.name === filterTypes.Advertiser) {
                item.isVisible = true;
            }
        });
    },

    [`${storePrefix}fetchReportTypeAndDateBySessionStorage`](state) {
        let ss = window.sessionStorage.getItem(state.sessionStorageKey);

        if (ss) {
            let obj = JSON.parse(ss);

            if (obj) {

                if (obj.reportType) {
                    state.currentReport = obj.reportType;
                }

                if (obj.reportTime) {

                    state.revenueTime.from = new Date(obj.reportTime.from);
                    state.revenueTime.to = new Date(obj.reportTime.to);
                    state.revenueTime.period = parseInt(obj.reportTime.period);
                }

                if (obj.reportDatatableFilters && obj.reportFilterItems) {

                    state.revenueDatatableFilters = obj.reportDatatableFilters;
                    state.revenueFilterItems = obj.reportFilterItems;
                }
            }
        }
    },

    [`${storePrefix}setAppFilterItemsByPlatform`](state) {

        let PlatformFilter = state.revenueFilterItems.find((c) => {
            return c.name == filterTypes.Platform;
        });

        let PlatformOption = PlatformFilter.options.find(item => {
            return item.selected === true
        });

        let AppFilter = state.revenueFilterItems.find((c) => {
            return c.name == filterTypes.Apps;
        });

        let AdvertiserFilter = state.revenueFilterItems.find((c) => {
            return c.name == filterTypes.Advertiser;
        });

        if (PlatformOption) {

            if (PlatformOption.isAll === true) {
                AppFilter.options.forEach(item => {
                    item.visible = true;
                });
                AdvertiserFilter.options.forEach(item => {
                    item.visible = true;
                });
            } else {
                AppFilter.options.forEach(item => {

                    if (item.isAll === true) {
                        item.visible = true;
                    } else {
                        if (item.platform && item.platform.toLowerCase() !== PlatformOption.name.toLowerCase()) {
                            item.visible = false;
                        } else {
                            item.visible = true;
                        }
                    }

                });

                AdvertiserFilter.options.forEach(item => {

                    if (item.isAll === true) {
                        item.visible = true;
                    } else {
                        if (item.platform && item.platform.toLowerCase() !== PlatformOption.name.toLowerCase()) {
                            item.visible = false;
                        } else {
                            item.visible = true;
                        }
                    }
                });
            }
        }
    },

    [`${storePrefix}resetAllFilters`](state) {

        state.revenueFilterItems.forEach(filter => {

            if (filter.id !== filterTypes.Platform) {
                if (filter.id == filterTypes.Apps) {
                    filter.options.forEach(option => {
                        option.selected = false;
                    });
                }

                filter.options.forEach(option => {
                    option.selected = false;
                });
            }
        });
    },

    [`${storePrefix}updateRevenueOptionsFilters`](state, filterId) {//mutate so selected options will shown first

        let item = state.revenueFilterItems.find((c) => {
            return c.id == filterId;
        });

        if (item && item.options && item.id !== filterTypes.Platform) {

            let options = item.options;
            let result = [];

            let isAllItem = options.filter(function (item) {
                return item.isAll && item.isAll === true;
            });

            result = result.concat(isAllItem);

            let selected = options.filter(function (item) {
                return item.selected === true && !item.isAll;
            }).sort(function (a, b) {

                let val1 = a.name.toLowerCase();
                let val2 = b.name.toLowerCase();

                if (val1 && val1) {
                    if (val1 < val2) {
                        return -1;
                    } else if (val1 > val2) {
                        return 1;
                    } else {
                        return 0;
                    }
                } else {
                    return 0;
                }
            });

            result = result.concat(selected);

            let unSelected = options.filter(function (item) {
                return item.selected === false && !item.isAll;
            }).sort(function (a, b) {

                let val1 = a ? a.name.toLowerCase() : undefined;
                let val2 = b ? b.name.toLowerCase() : undefined;

                if (val1 && val1) {
                    if (val1 < val2) {
                        return -1;
                    } else if (val1 > val2) {
                        return 1;
                    } else {
                        return 0;
                    }
                } else {
                    return 0;
                }
            });

            item.options = result.concat(unSelected);

        }
    },

    [`${storePrefix}setReportType`](state, reportType) {

        state.currentReport = reportType;
    },

    [`${storePrefix}setDateRange`](state, payload) {
        state.revenueTime.from = payload.from;
        state.revenueTime.to = payload.to;
        state.revenueTime.period = payload.period ? payload.period.id : -1;
    },

    [`${storePrefix}updateRevenueData`](state, payload) {
        state.revenueData = payload;
    },

    [`${ storePrefix}setCurrentFilterItems`](state, payload) {

        let filterTypeName = payload.filterTypeName;
        let selectedOption = payload.selectedOption;
        let isSelected = payload.isSelected;
        let filteredItems = payload.filteredItems;

        var filterIndex = state.revenueFilterItems.findIndex(item => {
            return item.id === filterTypeName;
        });

        if (filterIndex > -1) {

            let selectedItems = 0;
            let visibleItems = 0;
            state.revenueFilterItems[filterIndex].options.forEach(item => {

                if (item.isAll && item.isAll === true) {
                    item.selected = false;
                }

                if (typeof selectedOption === "string") {
                    let name = item.name.toLowerCase();
                    if (name === selectedOption) {
                        item.selected = isSelected;
                    }
                } else if (typeof selectedOption === "number") {
                    let id = item.id;
                    if (id === selectedOption) {
                        item.selected = isSelected;
                    }
                }

                if (item.selected && item.isAll !== true) {
                    selectedItems++;
                }

                if (item.visible && item.isAll !== true) {
                    visibleItems++;
                }

            });

            let isAllItem = state.revenueFilterItems[filterIndex].options[0];

            if (isAllItem) {
                if (selectedItems == 0 && isAllItem.isAll === true && isAllItem.isAllSelected !== true) {
                    isAllItem.selected = true;
                }

                if (filteredItems && isAllItem.isAllSelected === true) {

                    let selectedOptions = filteredItems.filter(item => {
                        return item.selected === true || item.isAll === true;
                    });

                    if (selectedOptions.length === filteredItems.length) {
                        isAllItem.selected = true;
                    } else {
                        isAllItem.selected = false;
                    }
                }
            }
        }

    },

    [`${storePrefix}updateRevenueDataTableFilter`](state, payload) {

        let currentReport = state.currentReport;
        let filteredColumn = [];

        if (currentReport.type === reportTypes.Advertiser) {
            filteredColumn.push(columnNames.advertiserId);
        } else if (currentReport.type === reportTypes.Country) {
            filteredColumn.push(columnNames.Country);
        } else if (currentReport.type === reportTypes.Date) {
            filteredColumn.push(columnNames.date);
        } else if (currentReport.type === reportTypes.Placement) {
            filteredColumn.push(columnNames.Placement);
        } else if (currentReport.type === reportTypes.AppsPlacements) {
            filteredColumn.push(columnNames.PlacementId);
            filteredColumn.push(columnNames.pba_number);
        } else if (currentReport.type === reportTypes.CountryPlacement) {
            filteredColumn.push(columnNames.Country);
            filteredColumn.push(columnNames.PlacementId);
        } else if (currentReport.type === reportTypes.PlacementCountry) {
            filteredColumn.push(columnNames.Country);
            filteredColumn.push(columnNames.PlacementId);
        }

        state.revenueDatatableFilters.forEach(item => {

            let filterable = item.column == columnNames.pba_number || item.column == columnNames.Platform;
            if (filterable === false) {
                let filter = filteredColumn.find(fItem => {
                    return item.column === fItem;
                });

                if (filter) {
                    filterable = true;
                }
            }

            if (filterable === true) {
                item.isFilterable = true;
            } else {
                item.isFilterable = false;
            }

        });
    },

    [`${storePrefix}addFiltersDataTable`](state, payload) {

        let filterTypeName = payload.filterTypeName;
        let column = payload.column;
        let value = payload.value;

        if (value) {
            let filterInputType = state.revenueFilterItems.find(item => {
                return item.name === filterTypeName;
            }).type;

            let filter = {
                column: column,
                values: [],
                byValue: true
            };


            if (filterTypeName == filterTypes.Platform) {
                state.revenueDatatableFilters = [];
                filter.values = [value];
                state.revenueDatatableFilters.push(filter);
            } else {
                var filterIndex = state.revenueDatatableFilters.findIndex((c) => {
                    return c.column == filter.column;
                });

                if (filterIndex > -1) {
                    if (filterInputType === "checkbox") {
                        state.revenueDatatableFilters[filterIndex].values.push(value);
                    } else if (filterInputType === "radio") { // android or ios
                        state.revenueDatatableFilters[filterIndex].values = [value];
                    }
                } else {
                    filter.values.push(value);
                    state.revenueDatatableFilters.push(filter);
                }
            }
        }
    },

    [`${storePrefix}setSessionStorage`](state) {// session storage

        let obj = {
            reportType: state.currentReport,
            reportTime: state.revenueTime,
            reportDatatableFilters: state.revenueDatatableFilters,
            reportFilterItems: state.revenueFilterItems
        };

        let obj_json = JSON.stringify(obj);

        if (window.sessionStorage) {
            window.sessionStorage.setItem(state.sessionStorageKey, obj_json);
        }
    },

    [`${storePrefix}removeSubFilters`](state, payload) {

        let column = payload.column;
        let filterTypeName = payload.filterTypeName;
        let filterOptionValue = payload.value;

        let filterInputType = state.revenueFilterItems.find(item => {
            return item.name === filterTypeName;
        }).type;

        var filterIndex = state.revenueDatatableFilters.findIndex((c) => {
            return c.column == column;
        });

        if (filterInputType === "checkbox") {

            let currentDatatableFilter = state.revenueDatatableFilters.find(c => {
                return c.column === column;
            });


            if (currentDatatableFilter && currentDatatableFilter.values) {
                var filterOptionIndex = currentDatatableFilter.values.findIndex(value => {

                    if (typeof value === "string" && typeof filterOptionValue === "string") {
                        return value.toLowerCase() == filterOptionValue.toLowerCase();
                    } else {
                        return value == filterOptionValue;
                    }
                });

                if (filterOptionIndex > -1) {
                    currentDatatableFilter.values.splice(filterOptionIndex, 1);
                }

                if (currentDatatableFilter.values.length === 0) {
                    state.revenueDatatableFilters.splice(filterIndex, 1);
                }
            }
        } else if (filterInputType === "radio") {
            state.revenueDatatableFilters.splice(filterIndex, 1);
        }
    },

    [`${storePrefix}removeFilter`](state, payload) {

        let column = payload.column;
        let filterTypeName = payload.filterTypeName;
        let filterOptionValue = payload.value;

        var filterIndex = state.revenueDatatableFilters.findIndex((c) => {
            return c.column == column;
        });
        if (filterIndex > -1) {
            state.revenueDatatableFilters.splice(filterIndex, 1);
        }

        // set all options to true
        let filterItem = state.revenueFilterItems.find(item => {
            return item.id === filterTypeName;
        });

        if (filterItem) {
            filterItem.options.forEach(item => {
                if (item.isAll && item.isAll === true) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
            });
        }

    },

    [`${storePrefix}updateFiltersData`](state, payload) {

        if (!state.revenueData.rows || state.revenueData.rows.length == 0) {

            state.revenueFilterItems = new revenueFilterItems().items;

            return;
        }

        var columns = Object.values(state.revenueData.columns);
        var filterItems = state.revenueFilterItems.filter((c) => {
            return columns.includes(c.id);
        });

        //find columns indexs
        let AppNumberColumnIndex = columns.findIndex(column => {
            return column === columnNames.pba_number
        });
        let platformColumnIndex = columns.findIndex(column => {
            return column === columnNames.Platform
        });
        let PlacementAppNumberColumnIndex = columns.findIndex(column => {
            return column === columnNames.PlacementId
        });
        let AdvertiserAppNumberColumnIndex = columns.findIndex(column => {
            return column === columnNames.advertiserId
        });
        let appNameColumnIndex = columns.findIndex(column => {
            return column === columnNames.Apps
        });
        let AdvertiserPbNumberColumnIndex = columns.findIndex(column => {
            return column === columnNames.advertiser_pb_number
        });

        filterItems.forEach((filterItem) => {

            var tempFilterItemOptions = [];

            if (filterItem && filterItem.options && filterItem.options.length > 0) {
                tempFilterItemOptions = filterItem.options;
            }

            // sets the column values in the filter options
            let options = [];
            let columnIndex = columns.findIndex(column => {
                return column === filterItem.id
            });

            state.revenueData.rows.map((row) => {

                let value_id = undefined;
                let value_platform = row[platformColumnIndex] ? row[platformColumnIndex] : undefined;
                let value_name = row[columnIndex];
                let value_sub_name = undefined;

                if (filterItem.name == columnNames.Apps) {

                    value_id = row[AppNumberColumnIndex] ? row[AppNumberColumnIndex] : undefined;

                } else if (filterItem.name == columnNames.Advertiser) {

                    value_id = row[AdvertiserAppNumberColumnIndex] ? row[AdvertiserAppNumberColumnIndex] : undefined;

                } else if (filterItem.name == columnNames.advertiser_pb_number) {

                    value_id = row[AdvertiserPbNumberColumnIndex] ? row[AdvertiserPbNumberColumnIndex] : undefined;

                } else if (filterItem.name == columnNames.Placement) {

                    value_id = row[PlacementAppNumberColumnIndex] ? row[PlacementAppNumberColumnIndex] : undefined;
                    value_sub_name = row[appNameColumnIndex] ? row[appNameColumnIndex] : undefined;
                }

                // repeated values
                let optionsHasValue = false;
                options.forEach(item => {
                    if (item.id && item.id !== "" && item.id === value_id) {
                        optionsHasValue = true;
                    }
                });
                if (optionsHasValue) {
                    return;
                }

                let hasValue = options.find((c) => {

                    let result = (c.name === value_name);
                    result = result && (c.id === value_id);

                    return result;
                });

                let oldOptionIndex = tempFilterItemOptions.findIndex(c => {

                    let result = (c.name === value_name);
                    result = result && (c.id === value_id);

                    return result;

                });
                let oldOption = undefined;
                if (oldOptionIndex > -1) {
                    oldOption = Object.assign({}, tempFilterItemOptions[oldOptionIndex]);

                    tempFilterItemOptions.splice(oldOptionIndex, 1);
                }

                if (!hasValue) {
                    options.push(
                        {
                            id: value_id ? value_id : undefined,
                            name: value_name,
                            subName: value_sub_name ? value_sub_name : undefined,
                            platform: value_platform ? value_platform : undefined,
                            selected: oldOption ? oldOption.selected : false,
                            visible: true,
                            isAll: false
                        }
                    );
                }

            });

            let checkeNotRelatedOptions = tempFilterItemOptions.filter(item => {
                return item.selected === true || item.isAll === true;
            });

            let alllRelevantOptions = checkeNotRelatedOptions.concat(options);

            filterItem.options = alllRelevantOptions;

        });

    },

    [`${storePrefix}updateAdvertiserAppDetails`](state, app) {
        state.revenueAppsDetails.push(app[0]);
    },

    [`${storePrefix}setAllowAdvertiserReport`](state, allow) {
        state.isAllowedAdvertiserReport = allow;
    }
}

const actions = {

    fetchRevenueData(context) {

        return new Promise((resolve, reject) => {

            let dateRange = context.getters.getRevenueTime;
            let currentReport = context.getters.getCurrentReport;

            let fromDateTime = new Date(dateRange.from);
            let toDateTime = new Date(dateRange.to);

            let from = `${fromDateTime.getFullYear()}-${fromDateTime.getMonth() + 1}-${fromDateTime.getDate()}`; //ex: 2019-01-23
            let to = `${toDateTime.getFullYear()}-${toDateTime.getMonth() + 1}-${toDateTime.getDate()}`;

            var request = {
                type: currentReport.type,
                from: from,
                to: to
            };

            Vue.$http.post(revenueUrls.getRevenueData, request).then((response) => {

                let revenueData = response.data.revenueData;

                if (revenueData) {

                    context.commit(`${storePrefix}updateRevenueData`, revenueData);

                    context.commit(`${storePrefix}updateRevenueDataTableFilter`);

                    context.commit(`${storePrefix}updateFiltersData`);

                } else {
                    context.commit(`${storePrefix}updateRevenueData`, undefined);
                }

                resolve();

            }).catch((error) => {
                reject();
            });

        });

    },

    fetchRevenueAppDetails(context, payload) {

        return new Promise((resolve, reject) => {
            Vue.$http.post(revenueUrls.getPublisherApp, payload).then((response) => {
                if (response && response.data && response.data[0]) {
                    let app = response.data;
                    context.commit(`${storePrefix}updateAdvertiserAppDetails`, app);
                    resolve();
                } else {
                    reject();
                }
            }).catch((error) => {
                reject();
            });

        });

    },

    fetchIsAllowedAdvertiserReport(context, payload) {

        return new Promise((resolve, reject) => {
            Vue.$http.post(revenueUrls.allowAdvertiserReportUrl, payload).then((response) => {
                if (response && response.data) {
                    let allow = response.data.allow;
                    context.commit(`${storePrefix}setAllowAdvertiserReport`, allow);
                    resolve();
                } else {
                    reject();
                }
            }).catch((error) => {
                reject();
            });

        });

    },

    updateRevenueOptionsFilters(context, filterId) {
        context.commit(`${storePrefix}updateRevenueOptionsFilters`, filterId);
    },

    updateRevenueFilters(context, filter) {
        context.commit(`${storePrefix}updateRevenueFilters`, filter);
    },

    setReportType(context, reportType) {
        context.commit(`${storePrefix}setReportType`, reportType);
        context.commit(`${storePrefix}setSessionStorage`);
    },

    setDateRange(context, payload) {
        context.commit(`${storePrefix}setDateRange`, payload);
        context.commit(`${storePrefix}setSessionStorage`);
    },

    removeFilter(context, payload) {
        context.commit(`${storePrefix}removeFilter`, payload);
        context.commit(`${storePrefix}setSessionStorage`);
    },

    setAppFilterItemsByPlatform(context, payload) {
        context.commit(`${storePrefix}setAppFilterItemsByPlatform`, payload);
    },

    setFiltersDataTable(context, payload) {

        if (payload.remove === true) {
            context.commit(`${storePrefix}removeSubFilters`, payload);
        } else {
            context.commit(`${storePrefix}addFiltersDataTable`, payload);
        }

        context.commit(`${storePrefix}setSessionStorage`);
    },

    setCurrentFilterItems(context, payload) {
        context.commit(`${storePrefix}setCurrentFilterItems`, payload);
        context.commit(`${storePrefix}setSessionStorage`);
    },

    setAllRevenueOptionsFilters(context) {

        let filters = context.getters.getRevenueFilterItems;
        if (filters) {
            filters.forEach(filter => {
                context.commit(`${storePrefix}updateRevenueOptionsFilters`, filter.id);
            });
        }
    },

    resetAllFilters(context) {

        context.commit(`${storePrefix}resetAllFilters`); // except platform filter
        context.commit(`${storePrefix}setSessionStorage`);
    },

    fetchSessionStorageData(context) {

        context.commit(`${storePrefix}fetchReportTypeAndDateBySessionStorage`);
    },

    setDrpItemsVisibleForAdmin(context, payload) {
        context.commit(`${storePrefix}setDrpItemsVisibleForAdmin`, payload);
    },

    setIsAllSelected(context, payload) {
        context.commit(`${storePrefix}setIsAllSelected`, payload);
    },

    setAllSelectedItems(context, payload) {
        context.commit(`${storePrefix}setAllSelectedItems`, payload);
    }

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/components/Revenue/store/revenue.js